var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReduceStress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 42,
    height: 42,
    transform: "translate(364 489)",
    fill: "#ebc5c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05235d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305eba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(-364 -489)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fear",
    transform: "translate(364.27 489.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M26.558,16.379a.818.818,0,0,1-.1-.006,15.253,15.253,0,0,1-8.1-3.529,8.15,8.15,0,0,0-2.349,1.144.81.81,0,1,1-.932-1.325,9.76,9.76,0,0,1,3.293-1.5.81.81,0,0,1,.735.184,13.652,13.652,0,0,0,7.549,3.419.81.81,0,0,1-.094,1.614Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M20.73,28.621a8.327,8.327,0,0,1-7.1-3.932.81.81,0,1,1,1.373-.86,6.749,6.749,0,0,0,11.443.005.81.81,0,1,1,1.372.861A8.328,8.328,0,0,1,20.73,28.621Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M29.513,13.064a.81.81,0,0,1-.793-.651,8.149,8.149,0,0,0-15.97-.036.81.81,0,0,1-1.587-.325,9.769,9.769,0,0,1,19.145.043.811.811,0,0,1-.795.969Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M11.959,31.5a.81.81,0,0,1-.124-1.61l2.8-.438a2.006,2.006,0,0,0,1.7-1.992.81.81,0,0,1,1.62,0,3.635,3.635,0,0,1-3.075,3.592l-2.8.438A.816.816,0,0,1,11.959,31.5Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M29.5,31.5a.816.816,0,0,1-.126-.01l-2.8-.437A3.635,3.635,0,0,1,23.5,27.458a.81.81,0,0,1,1.62,0,2.006,2.006,0,0,0,1.705,1.992l2.8.437A.81.81,0,0,1,29.5,31.5Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M20.73,32.843a7.4,7.4,0,0,1-5.5-2.454.81.81,0,0,1,1.205-1.082,5.765,5.765,0,0,0,8.584,0,.81.81,0,0,1,1.205,1.082A7.4,7.4,0,0,1,20.73,32.843Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M.767,1.154a.807.807,0,0,1-.331-.071L-.331.739A.81.81,0,0,1-.739-.331.81.81,0,0,1,.331-.739L1.1-.4A.81.81,0,0,1,.767,1.154Z",
    transform: "translate(23.022 19.211)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M0,1.154A.81.81,0,0,1-.739.675.81.81,0,0,1-.331-.4L.436-.739a.81.81,0,0,1,1.07.408A.81.81,0,0,1,1.1.739l-.767.344A.807.807,0,0,1,0,1.154Z",
    transform: "translate(17.671 19.211)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M36.256,41.458a5.2,5.2,0,0,1-4.884-3.408L25.806,22.9a.81.81,0,0,1,.418-1.013l5.471-2.551a.81.81,0,0,1,1.045.331l3.088,5.385a.81.81,0,0,1-1.4.806L31.7,21.114l-4.122,1.922,5.31,14.455a3.584,3.584,0,1,0,6.473-3.018l-1.317-2.3a.81.81,0,1,1,1.4-.806l1.317,2.3a5.2,5.2,0,0,1-4.515,7.79Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M27.48,23a.81.81,0,0,1-.741-.484,7.934,7.934,0,0,1-.638-3.87l.148-1.695L25.287,14.4a2.783,2.783,0,0,1,.1-2.184,2.77,2.77,0,0,1,4.413-.79l.957.919a4.712,4.712,0,0,1,1.436,3.826l-.39,4.456a.81.81,0,0,1-.464.663l-3.515,1.639A.81.81,0,0,1,27.48,23Zm.4-10.732A1.151,1.151,0,0,0,26.8,13.826l1.027,2.728a.81.81,0,0,1,.049.356l-.164,1.878a6.311,6.311,0,0,0,.224,2.3l2.291-1.068.349-3.99a3.1,3.1,0,0,0-.945-2.517l-.957-.919A1.141,1.141,0,0,0,27.884,12.269Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M5.2,41.461A5.2,5.2,0,0,1,.691,33.668l8.031-14a.81.81,0,0,1,1.045-.331l5.471,2.551a.81.81,0,0,1,.418,1.013L10.089,38.05A5.225,5.225,0,0,1,5.2,41.461ZM9.756,21.114,2.1,34.473A3.586,3.586,0,0,0,5.2,39.841a3.6,3.6,0,0,0,3.367-2.35l5.31-14.455Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M13.981,23a.81.81,0,0,1-.342-.076l-3.515-1.639a.81.81,0,0,1-.464-.663l-.39-4.456a4.712,4.712,0,0,1,1.436-3.826l.956-.919a2.77,2.77,0,0,1,4.412.79,2.783,2.783,0,0,1,.1,2.184l-.962,2.556.148,1.695a7.934,7.934,0,0,1-.638,3.87.81.81,0,0,1-.741.484Zm-2.749-2.985,2.291,1.068a6.311,6.311,0,0,0,.224-2.3l-.164-1.878a.81.81,0,0,1,.049-.356l1.027-2.728a1.151,1.151,0,0,0-1.081-1.557,1.141,1.141,0,0,0-.793.321l-.957.919a3.1,3.1,0,0,0-.945,2.517Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M22.019,24.069a.807.807,0,0,1-.573-.237,1.015,1.015,0,0,0-1.433,0,.81.81,0,0,1-1.145-1.145,2.636,2.636,0,0,1,3.724,0,.81.81,0,0,1-.573,1.382Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M35,15.144a.81.81,0,0,1-.4-1.514l2.939-1.673L36.228,11.2a.81.81,0,0,1,.057-1.432L40.3,7.853A.81.81,0,0,1,41,9.315l-2.628,1.252,1.2.693a.81.81,0,0,1,0,1.4L35.4,15.037A.806.806,0,0,1,35,15.144Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M31.9,9.059a.81.81,0,0,1-.633-1.314L33.368,5.1l-1.5-.215a.81.81,0,0,1-.48-1.351L34.406.261a.81.81,0,0,1,1.191,1.1L33.623,3.5l1.372.2A.81.81,0,0,1,35.515,5L32.53,8.753A.808.808,0,0,1,31.9,9.059Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M6.459,15.144a.806.806,0,0,1-.4-.106L1.893,12.665a.81.81,0,0,1,0-1.4l1.2-.693L.462,9.315a.81.81,0,0,1,.7-1.462L5.176,9.767A.81.81,0,0,1,5.233,11.2l-1.311.757L6.86,13.63a.81.81,0,0,1-.4,1.514Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M9.565,9.059a.808.808,0,0,1-.634-.306L5.946,5a.81.81,0,0,1,.519-1.306l1.372-.2L5.865,1.359A.81.81,0,1,1,7.055.261l3.017,3.272a.81.81,0,0,1-.48,1.351l-1.5.215L10.2,7.745a.81.81,0,0,1-.633,1.314Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    transform: "translate(36.947 28.607)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M31.212.81H0A.81.81,0,0,1-.81,0,.81.81,0,0,1,0-.81H31.212a.81.81,0,0,1,.81.81A.81.81,0,0,1,31.212.81Z",
    transform: "translate(5.124 40.65)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceStress);
export default __webpack_public_path__ + "static/media/reduce-stress.41bdede66392cc8203b5c85dff195dca.svg";
export { ForwardRef as ReactComponent };